import { Typography } from "@mui/material";
import RequiredAsterisk from "../required_asterisk/required_asterisk";

export const fieldHeader = (title: string, isRequired: boolean) => {
  return (
    <Typography variant="subtitle2" fontWeight={600} mb={1}>
      {title} {isRequired && <RequiredAsterisk />} :
    </Typography>
  );
};
